// Constants
const MS_PER_HOUR = 3600000;

/**
 * Format a Date object to "YYYY-MM-DD HH:mm" string for datetime inputs
 * @param {Date} date
 * @returns {string}
 */
export const formatDateForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

/**
 * Add hours to a checkin date and return the resulting checkout Date
 * @param {string|Date} checkinDate
 * @param {number} hours
 * @returns {Date}
 */
export const calculateCheckoutDate = (checkinDate, hours) => {
    const checkin = new Date(checkinDate);
    return new Date(checkin.getTime() + (hours * MS_PER_HOUR));
};

/**
 * Extract numeric hours from a duration string
 * Handles formats: "2 hours", "2-hours", "2"
 * @param {string} durationString - e.g. "2 hours" or "2-hours"
 * @returns {number}
 */
export const extractHoursFromDuration = (durationString) => {
    return parseInt(durationString || 0, 10);
};

/**
 * Calculate the duration in hours between two date strings
 * @param {string|Date} startDate
 * @param {string|Date} endDate
 * @returns {number}
 */
export const calculateDurationInHours = (startDate, endDate) => {
    const durationMs = new Date(endDate) - new Date(startDate);
    return durationMs / MS_PER_HOUR;
};

